import { render, staticRenderFns } from "./UnboxOverview.vue?vue&type=template&id=542fa781&scoped=true"
import script from "./UnboxOverview.vue?vue&type=script&lang=js"
export * from "./UnboxOverview.vue?vue&type=script&lang=js"
import style0 from "./UnboxOverview.vue?vue&type=style&index=0&id=542fa781&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542fa781",
  null
  
)

export default component.exports